import styled from 'styled-components';

export default styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    padding: 18px;
    border-right: 1px solid ${({ theme }) => theme.colors.gray};
`;
